import httpClient from "@/api/httpClient";
import BookingCheckoutResponse from "@/model/BookingCheckoutResponse";
import BookingPage from "@/model/BookingPage";
import BookingResponse from "@/model/BookingResponse";
import CancellationQuote from "@/model/CancellationQuote";
import CreateBookingRequest from "@/model/CreateBookingRequest";

const PAGE_SIZE = 50;

/** Creates a PENDING_PAYMENT booking holding the nights, with the Stripe client secret to pay it. */
function createBooking(
  accessToken: string,
  request: CreateBookingRequest
): Promise<BookingCheckoutResponse> {
  return httpClient.postJson<BookingCheckoutResponse>(
    "/api/bookings",
    request,
    accessToken
  );
}

/** The client secret again, to resume paying while the hold lasts. */
function getCheckout(
  accessToken: string,
  id: string
): Promise<BookingCheckoutResponse> {
  return httpClient.getJson<BookingCheckoutResponse>(
    `/api/bookings/${id}/checkout`,
    accessToken
  );
}

function getBooking(accessToken: string, id: string): Promise<BookingResponse> {
  return httpClient.getJson<BookingResponse>(
    `/api/bookings/${id}`,
    accessToken
  );
}

function listMyBookings(accessToken: string): Promise<BookingPage> {
  return httpClient.getJson<BookingPage>(
    `/api/bookings/mine?page=0&size=${PAGE_SIZE}`,
    accessToken
  );
}

function getCancellationQuote(
  accessToken: string,
  id: string
): Promise<CancellationQuote> {
  return httpClient.getJson<CancellationQuote>(
    `/api/bookings/${id}/cancellation-quote`,
    accessToken
  );
}

function cancelBooking(
  accessToken: string,
  id: string
): Promise<BookingResponse> {
  return httpClient.postJson<BookingResponse>(
    `/api/bookings/${id}/cancel`,
    {},
    accessToken
  );
}

const bookingsApi = {
  createBooking,
  getCheckout,
  getBooking,
  listMyBookings,
  getCancellationQuote,
  cancelBooking,
};

export default bookingsApi;
